module.exports = {
  slots: [
    {
      slotId: 'menu-bar',
      components: [
        {
          widgetId: 'MenuBar',
          props: {
            second_set: [
              {
                subnav: [
                  {
                    label: 'Contact Us',
                    url: '/contact-us'
                  }, {
                    label: 'FAQ',
                    url: '/faq'
                  }
                ],
                label: 'Support'
              },
              {
                label: 'Sign In',
                url: '/login',
                loggedInLabel: 'My FF'
              }
            ],
            first_set: [
              {
                subnav: [],
                label: 'FF 91',
                url: '/ff-91'
              }, {
                subnav: [],
                label: 'FFZERO1',
                url: '/ffzero1'
              }, {
                subnav: [],
                label: 'Formula E',
                url: '/formula-e'
              }, {
                subnav: [],
                label: 'FUTURESIGHT',
                url: '/futuresight'
              }, {
                subnav: [
                  {
                    label: 'Our Company',
                    url: '/our-company'
                  }, {
                    label: 'Formula E',
                    url: '/formula-e'
                  }, {
                    label: 'Careers',
                    url: '/careers'
                  }, {
                    label: 'Press Room',
                    url: '/press'
                  }
                ],
                url: '',
                label: 'About Us'
              }
            ],
            logo_link: '/',
            color_theme: 'LIGHT',
            scroll_effect: false
          }
        }
      ]
    }, {
      slotId: 'content',
      components: [
        {
          widgetId: 'HeroLanding',
          props: {
            text_animation: false,
            play_on_enter: false,
            loop: true,
            color_theme: 'DARK',
            bg_image: {
              url: '',
              dark_overlay: 0
            },
            bg_video: {
              url: 'https://genesis-cdn.ff.com/homepage/01_marquee/genesis_ff91_emergence_3mbps.mp4',
              cover: 'https://genesis-cdn.ff.com/homepage/01_marquee/genesis_cover_image.jpg'
            },
            cta_block: {
              section: '',
              title: 'experience a new species',
              subtitle: '',
              description: '',
              buttons: [
                {
                  label: 'explore ff 91',
                  url: '/ff-91'
                },
                {
                  label: 'preorder',
                  url: '/reserve'
                }
              ]
            }
          }
        },
        {
          widgetId: 'Billboard',
          props: {
            parallax_effect: {
              speed: 300,
              enable: true
            },
            links: [
              {
                url: '/ff-91',
                label: 'FF 91',
                bgimage: 'https://genesis-cdn.ff.com/homepage/02_slats/01_ff91.jpg',
                color_theme: 'DARK'
              },
              {
                url: '/ffzero1',
                label: 'FFZERO1',
                bgimage: 'https://genesis-cdn.ff.com/homepage/02_slats/02_ffzero1.jpg',
                color_theme: 'LIGHT'
              },
              {
                url: '/our-company',
                label: 'Our Company',
                bgimage: 'https://genesis-cdn.ff.com/homepage/02_slats/03_ourcompany.jpg',
                color_theme: 'DARK'
              },
              {
                url: '/futuresight',
                label: 'FutureSight',
                bgimage: 'https://genesis-cdn.ff.com/homepage/02_slats/04_futuresight.jpg',
                color_theme: 'LIGHT'
              }
            ]
          }
        }, {
          widgetId: 'Subscribe',
          props: {
            redirect_link: '/cn/subscribe',
            title: 'Get the latest news and important updates from FF',
            expandable: true,
            region: 'US',
            scroll_in_animation: true,
            color_theme: 'DARK'
          }
        }
      ]
    }, {
      slotId: 'footer',
      components: [
        {
          widgetId: 'Footer',
          props: {
            items: [
              { url: '/sitemap', label: 'Sitemap' },
              { url: '/privacy-policy', label: 'Privacy & Legal' },
              { url: '/contact-us', label: 'Contact Us' }
            ],
            regions: [
              {
                value: 'US',
                imgUrl: 'https://genesis-cdn.ff.com/icon-en.png'
              }, {
                value: 'CN',
                imgUrl: 'https://genesis-cdn.ff.com/icon-china.png'
              }
            ],
            socialLinks: [
              { url: 'https://linkedin.com', icon: 'ff-icon-social-linkedin' },
              { url: 'https://youtube.com', icon: 'ff-icon-social-youtube' },
              { url: 'https://twitter.com', icon: 'ff-icon-social-twitter' },
              { url: 'https://facebook.com', icon: 'ff-icon-social-facebook' },
              { url: 'https://instagram.com', icon: 'ff-icon-social-instagram' }
            ],
            copyright: {
              text: 'Faraday&Future Inc. The Faraday Future name and logo are trademarks of Faraday&Future Inc. All rights reserved.'
            }
          }
        }
      ]
    }
  ],
  templateSettings: {
    subnav_padding: false,
    background_image: '',
    overlapping_menubar: false
  }
};
